import moment from "moment";
import ApiService from "../../../../apiService";

const odontogramHelper = {
  postICD: function (teethElement, patient, diagnoseArgs) {
    const diagnose = Array.isArray(diagnoseArgs)
      ? diagnoseArgs.map((v) => ({
          visit_id: patient.id,
          visit_inpatient_detail_id: "1",
          icd_code: v.code,
          icd_name: v.name,
          explanation: "-",
          date: moment(new Date()).format("YYYY-MM-DD"),
          case: v.case,
          elemen_teeth: teethElement,
          log: 0,
          examination_type_id: "1",
        }))
      : [
          {
            visit_id: patient.id,
            visit_inpatient_detail_id: "1",
            icd_code: diagnoseArgs.code,
            icd_name: diagnoseArgs.name,
            explanation: "-",
            date: moment(new Date()).format("YYYY-MM-DD"),
            case: diagnoseArgs.case,
            elemen_teeth: teethElement,
            log: 0,
            examination_type_id: "1",
          },
        ];

    return { diagnose };
  },

  postTreatment: function (patient, treatmentArgs) {
    console.log(patient);
    if (!Object.keys(treatmentArgs).length) return null;
    const treatment = Array.isArray(treatmentArgs)
      ? treatmentArgs.map((v) => ({
          visit_id: patient.id,
          visit_inpatient_detail_id: "1",
          treatment_id: v.value,
          treatment_name: v.label,
          log: "no",
          payments: patient.payments,
        }))
      : [
          {
            visit_id: patient.id,
            visit_inpatient_detail_id: "1",
            treatment_id: treatmentArgs.value,
            treatment_name: treatmentArgs.label,
            log: "no",
            payments: patient.payments,
          },
        ];
    return { treatment };
  },

  postTeethAnamnese: function (teethElement, patient, icd, treatment, field) {
    return {
      visit_id: patient.id,
      teeth_no: teethElement,
      anamnese: "Anamnese",
      status_gigi: field.status_gigi || "",
      diagnosa: Array.isArray(icd)
        ? icd.length
          ? icd[0].code || ""
          : ""
        : icd.code || "",
      akar_gigi: "ya",
      tindakan: Array.isArray(treatment)
        ? treatment.length
          ? treatment[0].value || null
          : null
        : treatment.value || null,
      teeth_ce: field.teeth_ce,
      teeth_ce_plus: field.teeth_ce_plus,
      teeth_sondasi: field.teeth_sondasi,
      teeth_sondasi_plus: field.teeth_sondasi_plus,
      teeth_perkusi: field.teeth_perkusi,
      teeth_perkusi_plus: field.teeth_perkusi_plus,
      teeth_palpasi: field.teeth_palpasi,
      teeth_palpasi_plus: field.teeth_palpasi_plus,
      catatan: field.catatan,
      log: field.log,
      anamnese_diagnoses: Array.isArray(icd)
        ? icd.map((v) => v.code || "")
        : [icd.code || ""],
      anamnese_treatments: Array.isArray(treatment)
        ? treatment.map((v) => v.value || null)
        : [treatment.value || null],
    };
  },

  submitTeethAnamnese: async function (
    teethElement,
    patient,
    icd,
    treatments,
    field
  ) {
    const icdData = this.postICD(teethElement, patient, icd);
    const treatmentData = this.postTreatment(patient, treatments);
    const teethAnamneseData = this.postTeethAnamnese(
      teethElement,
      patient,
      icd,
      treatments,
      field
    );

    const data = [
      {
        url: "/registration/treatment/create",
        data: treatmentData,
        name: "treatment",
      },
      {
        url: "/management/diagnoses/create",
        data: icdData,
        name: "diagnoses",
      },
      {
        url: "/management/teeth_anamneses/create",
        data: teethAnamneseData,
        name: "teethAnamnese",
      },
    ];

    // const response = await ApiService.multiPost(data);
    // if (response) {
    //   console.log(response);

    //   return response;
    // }
    const response = { treatment: "", diagnoses: "", teethAnamnese: "" };
    const treatment = await ApiService.post(data[0].url, data[0].data);
    if (treatment.code === 200) {
      response.treatment = treatment;
    } else {
      // return { ...response, isSuccess: true };
    }
    // if (icd.toString() == 0) {
    //   return { ...response, isSuccess: true };
    // }
    let icdx = false;
    if (
      Array.isArray(icd) &&
      icd.length > 0 &&
      icd[0] !== 0 &&
      typeof icd[0] === "object" &&
      icd[0] !== null
    ) {
      icdx = await ApiService.post(data[1].url, data[1].data);
    }
    if (icdx) {
      if (icdx.code === 200) {
        response.diagnoses = icdx;
        const ass = await ApiService.post(data[2].url, {
          ...data[2].data,
          diagnoses: icdx.data,
          treatments: response.treatment?.data ?? [],
        });
        if (ass.code === 200) {
          response.teethAnamnese = ass;
          return { ...response, isSuccess: true };
        } else {
          return { ...response, isSuccess: false };
        }
      }
    } else {
      const ass = await ApiService.post(data[2].url, {
        ...data[2].data,
        diagnoses: icdx.data,
        treatments: response.treatment?.data ?? [],
      });
      if (ass.code === 200) {
        response.teethAnamnese = ass;
        return { ...response, isSuccess: true };
      } else {
        return { ...response, isSuccess: false };
      }
    }
  },
};

export default odontogramHelper;
